import { Injectable } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { map, Observable, of, switchMap } from 'rxjs'
import { ExternalUserNavItemsProvider } from './external/external-user-nav-items.provider'
import { InternalUserNavItemsProvider } from './internal/internal-user-nav-items.provider'
import { SideNavGroup, SideNavItem } from './side-nav-item'

@Injectable({
  providedIn: 'root',
})
export class SideNavItemsProvider {
  constructor(
    private readonly internalUserNavItemsProvider: InternalUserNavItemsProvider,
    private readonly externalUserNavItemsProvider: ExternalUserNavItemsProvider,
    private readonly store: Store,
  ) {}

  provide(courtSystemId: Uuid | undefined): Observable<{ navGroups: SideNavGroup[]; footerItems: SideNavItem[] }> {
    const hasPermissionsInCourtSystem = courtSystemId
      ? this.store.select(UserState.getEnabledPermissions).pipe(map(fn => fn(courtSystemId).length > 0))
      : of(false)

    return hasPermissionsInCourtSystem.pipe(
      switchMap(hasPermissions => {
        if (courtSystemId && hasPermissions) {
          return this.internalUserNavItemsProvider.provide(courtSystemId)
        } else {
          return this.externalUserNavItemsProvider.provide()
        }
      }),
    )
  }
}
